Mo
<!-- Inspiré de :https://www.digitalocean.com/community/tutorials/how-to-handle-file-uploads-in-vue-2 -->

<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid, validate }" tag="div">
    <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @input="validate({ silent: true })">
      <div class="container p-0">
        <div
          v-if="!$isMobile()"
          id="glisser-deposer-overlay"
          class="document-container d-flex flex-column justify-content-center align-items-center text-center invisible"
        >
          <div class="cadre-drag-drop bg-white d-flex flex-column justify-content-center">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <div>
                <svg-icon
                  class="svg-icon-big rotate-25 py-0 mr-2"
                  icon-name="icone-photo"
                ></svg-icon>
                <svg-icon class="svg-icon-big py-0 ml-2" icon-name="ic-file"></svg-icon>
              </div>

              <div class="mt-2" v-html="content.libDragDropExecution" />
            </div>
          </div>
          <span class="petitTexte pt-1 securise-drag-drop">
            <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
            {{ content.libSecurise }}
          </span>
        </div>

        <div
          v-show="filesCount === 2 && erreurNombreFichier.montrerMessage"
          id="bloc-nombre-fichier"
          class="pr-1 row"
        >
          <div class="d-inline-flex col">
            <div class="cercleErreur cercleErreur-televersement mr-1">
              <span class="cercleErreur-contenu">!</span>
            </div>
            <div class="d-flex">
              <ul class="pl-0 m-0 d-inline-block">
                <li id="message-nombre-fichier" class="televersementInvalide"></li>
              </ul>
            </div>
          </div>
        </div>

        <form enctype="multipart/form-data" novalidate>
          <FilesSender :is="componentFilesSender">
            <template #slotTeleversement>
              <!-- Premier -->
              <ValidationProvider rules="required">
                <b-form-group v-model="doc1Selectionne">
                  <div class="selection-document-parent my-2">
                    <div v-if="!$isMobile()" v-html="content.libTitreDoc1"></div>
                    <TeleversementErrors id="erreur-televersement-premier"> </TeleversementErrors>

                    <div
                      id="cadre-selection-document-premier"
                      class="cadre-selection-document bordure-cadre-opaque d-flex flex-column justify-content-center my-1 mx-0 px-2 py-1 pt-sm-2"
                    >
                      <div
                        v-if="$isMobile()"
                        :class="doc1Selectionne ? 'd-flex float-left' : 'mb-n1'"
                        v-html="content.libTitreDoc1"
                      />
                      <div :class="doc1Selectionne ? 'd-flex float-left' : 'flex-row'">
                        <div
                          id="televersement__file-area-premier"
                          :class="{
                            'd-none': !doc1Selectionne,
                          }"
                        >
                          <div
                            class="cadre-photo w-100 h-100 flex-row justify-content-end float-left"
                          >
                            <div
                              id="televersement__preview-area-premier"
                              data-is="container-files-premier"
                            >
                              <button
                                id="button-remove-premier"
                                type="button"
                                class="btnVide positionBtnFermer p-0 mr-2 mt-2 mb-n5 float-right"
                                data-action="remove-file-premier"
                              >
                                <svg-icon
                                  class="btnVide positionBtnFermer svg-icon typeTitre py-0"
                                  icon-name="icone-fermer-v2"
                                  stroke="currentColor"
                                  fill="$couleur-fond-primaire"
                                >
                                </svg-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          id="televersement__selection-area-premier"
                          :class="{
                            'd-none': doc1Selectionne,
                          }"
                        >
                          <div v-if="!$isMobile()" class="mx-auto">
                            <svg-icon
                              class="typeTresGrandTitre p-0 m-1 cursor_pointer"
                              icon-name="ic-upload-file"
                              stroke="currentColor"
                              fill="$couleur-fond-primaire"
                            ></svg-icon>
                            <div class="m-0 mb-1" v-html="content.libDragDrop" />
                          </div>

                          <label>
                            <input
                              id="file-input-premier"
                              type="file"
                              class="d-none input-file"
                              accept=".jpg,.pdf,.png,.jpe,.pjepg"
                              @change="ajoutFichier('premier')"
                            />
                          </label>
                          <b-button
                            variant="primaire"
                            class="btn shadow w-100 w-md-auto mb-1 mx-xs-auto py-1 px-0 px-md-5"
                            onclick="document.getElementById('file-input-premier').click()"
                          >
                            <span v-html="content.libBoutonSelectionnerDocument" />
                          </b-button>
                        </div>
                        <div
                          v-if="$isMobile()"
                          class="info-document d-flex petitTexte justify-content-center"
                          :class="doc1Selectionne ? 'd-flex mt-auto ml-auto' : 'mb-n1'"
                        >
                          <span class="pl-2">
                            <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                            {{ content.libSecurise }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="!$isMobile()"
                      class="info-document d-flex petitTexte justify-content-between"
                    >
                      <p class="my-0" v-html="content.libFormat" />
                      <span class="pl-2">
                        <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                        {{ content.libSecurise }}
                      </span>
                    </div>
                  </div>
                </b-form-group>
              </ValidationProvider>
              <!-- Deuxieme -->
              <ValidationProvider rules="required">
                <b-form-group v-model="doc2Selectionne">
                  <!-- Deuxieme -->
                  <div class="selection-document-parent my-2">
                    <div v-if="!$isMobile()" v-html="content.libTitreDoc2" />
                    <TeleversementErrors id="erreur-televersement-deuxieme"> </TeleversementErrors>

                    <div
                      id="cadre-selection-document-deuxieme"
                      class="cadre-selection-document bordure-cadre-opaque d-flex flex-column justify-content-center my-1 mx-0 px-2 py-1 pt-sm-2"
                    >
                      <div
                        v-if="$isMobile()"
                        :class="doc2Selectionne ? 'd-flex float-left' : 'mb-n1'"
                        v-html="content.libTitreDoc2"
                      />
                      <div :class="doc2Selectionne ? 'd-flex float-left' : 'flex-row'">
                        <div
                          id="televersement__file-area-deuxieme"
                          :class="{
                            'd-none': !doc2Selectionne,
                          }"
                        >
                          <div
                            class="cadre-photo w-100 h-100 flex-row justify-content-end float-left pb-1"
                          >
                            <div
                              id="televersement__preview-area-deuxieme"
                              data-is="container-files-deuxieme"
                            >
                              <button
                                id="button-remove-deuxieme"
                                type="button"
                                class="btnVide positionBtnFermer p-0 mr-2 mt-2 mb-n5 float-right"
                                data-action="remove-file-deuxieme"
                              >
                                <svg-icon
                                  class="btnVide positionBtnFermer svg-icon typeTitre py-0"
                                  icon-name="icone-fermer-v2"
                                  stroke="currentColor"
                                  fill="$couleur-fond-primaire"
                                >
                                </svg-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          id="televersement__selection-area-deuxieme"
                          :class="{
                            'd-none': doc2Selectionne,
                          }"
                        >
                          <div v-if="!$isMobile()" class="mx-auto">
                            <svg-icon
                              class="typeTresGrandTitre p-0 m-1 cursor_pointer"
                              icon-name="ic-upload-file"
                              stroke="currentColor"
                              fill="$couleur-fond-primaire"
                            ></svg-icon>
                            <div class="texte m-0 mb-1" v-html="content.libDragDrop" />
                          </div>

                          <label>
                            <input
                              id="file-input-deuxieme"
                              type="file"
                              class="d-none input-file float-left"
                              accept=".jpg,.pdf,.png,.jpe,.pjepg"
                              @change="ajoutFichier('deuxieme')"
                            />
                          </label>
                          <b-button
                            variant="primaire"
                            class="btn shadow w-100 w-md-auto mb-1 mx-xs-auto py-1 px-0 px-md-5"
                            onclick="document.getElementById('file-input-deuxieme').click()"
                          >
                            <span v-html="content.libBoutonSelectionnerDocument" />
                          </b-button>
                        </div>
                        <div
                          v-if="$isMobile()"
                          class="info-document d-flex petitTexte justify-content-center"
                          :class="doc2Selectionne ? 'mt-auto ml-auto' : 'm-0'"
                        >
                          <span class="pl-2">
                            <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                            {{ content.libSecurise }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="!$isMobile()"
                      class="info-document d-flex petitTexte justify-content-between"
                    >
                      <p class="my-0" v-html="content.libFormat" />
                      <span class="pl-2">
                        <svg-icon icon-name="ic-security" class="mt-n0-5"> </svg-icon>
                        {{ content.libSecurise }}
                      </span>
                    </div>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </template>
          </FilesSender>
        </form>
        <TeleversementWarnings id="warning-televersement"> </TeleversementWarnings>
      </div>
      <div class="d-flex flex-column align-items-xs-center align-items-sm-start mx-4 mx-md-0">
        <b-button
          type="submit"
          variant="primaire"
          class="w-auto px-2 py-1 px-xs-5 mx-0 mb-2"
          :disabled="invalid || isSubmitted"
          :class="{ valid: !invalid }"
        >
          <div class="d-inline-flex w-auto">
            <div v-if="isSubmitted" class="mr-1">
              <b-spinner small :label="$t('chargement')"></b-spinner>
            </div>
            {{ content.libBoutonContinuer }}
          </div>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/services/api';
import i18n from '@/js/i18n';
import 'whatwg-fetch';

import FilesSender from '@/components/formulaire/televersement/FileSender.vue';
import TeleversementErrors from '@/components/formulaire/televersement/TeleversementErrors.vue';
import TeleversementWarnings from '@/components/formulaire/televersement/TeleversementWarnings.vue';

import mixinMessageErreur from '@/mixins/mixinMessageErreur';
import mixinSendFiles from '@/mixins/mixinSendFiles';

import { nettoyerLienExterne } from '@/helpers/AppHelpers';

export default {
  name: 'FormulaireTeleverserPieceIdentite',

  components: {
    FilesSender,
    TeleversementErrors,
    TeleversementWarnings,
  },
  mixins: [FilesSender, mixinMessageErreur],
  props: { content: { type: Object, required: true } },

  data() {
    return {
      uploadElementPosition: '',
      doc1Selectionne: null,
      doc2Selectionne: null,
      componentFilesSender: '',
      settings: {
        nameLength: 30,
        maxTaille: 0,
      },
      isSubmitted: null,
      erreurNombreFichier: {
        id: 'message-nombre-fichier',
        message: this.$i18n.t('validations.televersement.nombreFichier'),
        montrerMessage: false,
      },
    };
  },
  computed: {
    ...mapGetters('routes', ['getUrlFromWebsitePath']),
  },
  created() {
    this.loadUploadComponent();
  },
  mounted() {
    this.enableDragNDrop();
    this.mixinMessageErreur_getMessage(
      this.erreurNombreFichier.message,
      null,
      this.erreurNombreFichier.id
    );
  },
  methods: {
    ajoutFichier(uploadElementPosition) {
      this.uploadElementPosition = uploadElementPosition;
      if (this.erreurNombreFichier.montrerMessage) {
        this.erreurNombreFichier.montrerMessage = false;
      }
      this.mixinAddFile_addFile(uploadElementPosition);
    },
    async loadUploadComponent() {
      this.componentFilesSender = FilesSender;

      api
        .call(
          `upload-doc?lang=${i18n.locale}&site-id=validation-identite`,
          '/televersementLoadUpload',
          'GET',
          {
            headers: {
              'cache-control': 'no-cache',
              pragma: 'no-cache',
            },
          }
        )
        .then((response) => {
          if (
            response.data.status === 'SUCCESS' &&
            response.data.televersementInfo.flag == 'false'
          ) {
            this.settings = response.data;
            this.setTeleversementInfo(response.data.televersementInfo);
          } else {
            // TODO: message document déja uploadé
          }
        })
        .catch((error) => {
          if (error.url) {
            throw error;
          }
        });
    },
    async onSubmit() {
      if (this.isSubmitted) {
        return;
      }
      this.isSubmitted = true;
      await this.executerTache();
    },

    async executerTache() {
      const dossierClient = {
        clientId: sessionStorage.getItem('lq_client_uuid'),
        versionDonnees: this.$store.state.dossier.versionDonnees,
        clientMigrated: this.$store.state.dossier.clientMigrated,
      };
      await mixinSendFiles.mixinSendFiles_televerserFichiers(this.files, dossierClient).catch((error) => {
        this.isSubmitted = false;
        if (error.url) { 
          this.continuer(error.url);
        } else {
          console.error(error);
        }
      });
    },

    // Si route est nulle alors on prend la route provenant de Magnolia
    continuer(route) {
      let routeContinuer = route;

      // S'il n'y a pas d'erreur
      if (!routeContinuer) {
        // Route dans Magnolia
        routeContinuer =
          !this.$isMobile() && this.content.routeContinuerDesktop
            ? this.content.routeContinuerDesktop
            : this.content.routeContinuer;
      }

      const routeRecuperee = this.getUrlFromWebsitePath(routeContinuer);

      if (routeRecuperee === '') {
        window.location.replace(nettoyerLienExterne(routeContinuer));
      } else {
        this.$router.push(routeRecuperee).catch(() => {
          console.error(`Route inexistante: ${routeRecuperee}`);
        });
      }
    },
  },
};
</script>

<!-- "scope" n'est pas ajouté car sélecteur js natif -->
<style lang="scss">
.document-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $couleur-bg-glisser-deposer-overlay;
  color: $couleur-glisser-deposer-overlay;
  z-index: 300;
  transition: all 0.3s;

  &.invisible {
    opacity: 0;
  }

  .svg-icon-big {
    width: calc(3rem);
    height: calc(3rem);
  }

  .rotate-25 {
    transform: rotateZ(25deg);
  }
}

.cadre-selection-document {
  border-radius: 11px;
  opacity: 1;
  text-align: center;
  padding-top: 5%;
  padding-bottom: 5%;
  transition: all 0.5s;
  min-height: 9rem;
  max-height: 30vh;

  .btn {
    max-width: 300px;
  }
}
.cadre-selection-document-invalide {
  border: 2px dashed $couleur-erreur;
  border-radius: 11px;
  opacity: 1;
  text-align: center;
  padding-top: 5%;
  padding-bottom: 5%;
  transition: all 0.5s;
  min-height: 9rem;
  max-height: 30vh;

  .btn {
    max-width: 300px;
  }
}

.cadre-drag-drop {
  border: 2px dashed $couleur-primaire;
  border-radius: 4.5rem;
  opacity: 1;
  text-align: center;
  padding-top: 8%;
  padding-bottom: 8%;
  padding-left: 10%;
  padding-right: 10%;
  transition: all 0.5s;
  min-height: 9rem;
}

.cadre-photo {
  min-height: calc(6rem + 2vh);
  min-width: calc(6rem + 4vw);
  max-width: calc(10rem + 4vw);
  margin: auto;

  .positionBtnFermer {
    position: relative !important;
    z-index: 3 !important;
    transform: translate(50%, -50%);
  }
}

.photo {
  position: relative !important;
  z-index: 1 !important;
  min-height: calc(6rem + 2vh);
  min-width: calc(6rem + 4vw);
  max-width: calc(10rem + 4vw);
  display: block;
  margin: auto;
  background-color: $couleur-fond-primaire;
  border-radius: 0.33rem;

  img {
    position: relative !important;
    z-index: 2 !important;
    max-height: calc(9rem);
    display: block;
    object-fit: scale-down;
    margin: auto;
    width: auto;
  }
}
.info-document span {
  white-space: nowrap;
}

.document-selectionne {
  .titre-doc {
    text-align: left;
  }
  .photo {
    display: flex;
  }
}

.bordure-cadre-opaque {
  border: 2px dashed $couleur-primaire;
}
.bordure-cadre-transparent {
  border: 2px dashed transparentize($couleur-primaire, 0.5);
}

.securise-drag-drop {
  color: $couleur-primaire;
}
.mt-n0-5 {
  margin-top: -0.25rem;
}
</style>
